import classNames from 'classnames'

interface AnimatedMenuProps {
  onIsMenuOpenChange: (state: boolean) => void
  theme?: 'light' | 'dark'
}

const AnimatedMenu = ({ onIsMenuOpenChange, theme }: AnimatedMenuProps) => {
  const isLight = theme === 'light'
  return (
    <button
      className=" flex flex-row items-center pr-0 text-xl leading-none bg-transparent border rounded px-3 py-1 border-solid border-transparent cursor-pointer"
      type="button"
      onClick={() => onIsMenuOpenChange(true)}
    >
      <svg
        width="50"
        height="20"
        viewBox="0 0 50 20"
        fill="none"
        className="svg-bell"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          style={{ animationDelay: '0s' }}
          className="circle fill-green"
          cx="5"
          cy="10"
          r="5"
        ></circle>
        <circle
          style={{ animationDelay: '.1s' }}
          className="circle fill-mediumyellow"
          cx="25"
          cy="10"
          r="5"
        ></circle>
        <circle
          style={{ animationDelay: '.2s' }}
          className="circle fill-brown"
          cx="45"
          cy="10"
          r="5"
        ></circle>
      </svg>
      <span
        className={classNames(
          'font-decimal text-[14px] pl-3',
          isLight ? 'text-white' : 'text-ink'
        )}
      >
        MENU
      </span>
    </button>
  )
}
export default AnimatedMenu
